// extracted by mini-css-extract-plugin
export default {"summaryGrid":"SummaryRow_summaryGrid__zwyj1","cell":"SummaryRow_cell__5xwki"};